import { Directive, EventEmitter, Output } from '@angular/core';
import { FI_SWIPE_DIRECTION, FiSwipeBase } from './fi-swipe-base';

@Directive({
    selector: '[fiSwipeDown]',
    standalone: false,
})
export class FiSwipeDownDirective extends FiSwipeBase {
    @Output() fiSwipeDown = new EventEmitter<void>();

    protected _swipeEndCheck() {
        if (this.swipeDirection !== FI_SWIPE_DIRECTION.Vertical) {
            return;
        }

        const deltaY = this.lastTouchEvent.touches[0].screenY - this.touchStartEvent.touches[0].screenY;
        if (deltaY > this.threshold) {
            this.fiSwipeDown.emit();
        }
    }
}
